import { useBookingPubSub } from 'drycut-apollo';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  uid: string;
}>;

export default function BookingPubSubWrapper({ uid, children }: Props): React.ReactElement {
  // Real time updates for the waiting time and stylist list.
  useBookingPubSub({ uid, callback: (broadcast) => console.log(broadcast) });

  return <div id="booking-pubsub-wrapper">{children}</div>;
}
